<template>
  <h2
    v-if="variant == 'default'"
    class="page-title text-center text-lg-left theme-primary h1"
    ref="pageTitle"
    tabindex="-1"
    style="outline: none"
  >
    {{ title }}
  </h2>
  <h2 v-else class="text-center" ref="pageTitle" tabindex="-1" style="outline: none">{{ title }}</h2>
</template>

<script>
 import {sendAnalyticsData} from "../../../utility/miscellaneous";
export default {
  name: "PageHeader",

  props: {
    title: String,
    variant: {
      type: String,
      default: "default",
    },
  },
  watch: {
    title: {
      handler(val) {
        document.title = `${document.title.split("-")[0].trim()} - ${val}`;
        if(document.title.split("-")[1] != ' Investments Summary' || this.$root.isPortfolioDataLoad != undefined){
          sendAnalyticsData(this.$root);
        }
        setTimeout(() => this.$refs.pageTitle.focus(), 200);
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.page-title {
  font-weight: 600;
}
</style>
